export const ANALYTICS_TYPE = {
  Component: 'component',
};
